<template>
  <div class="vernier">
    <span
      class="dot"
      v-if="percent !== -1"
      :style="[offsetStyle]"
    />
    <span
      class="secDot"
      v-if="secPercent !== -1"
      :style="[offsetStyleSec]"
    />
    <div class="horizon">
      <span class="division" />
      <span class="division" />
      <span class="division" />
      <span class="division" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Vernier',
  props: {
    percent: {
      type: [Number, String],
      default: -1,
    },
    title: {
      type: [Number, String],
      default: '',
    },
    secPercent: {
      type: [Number, String],
      default: -1,
    },
    secTitle: {
      type: [Number, String],
      default: '',
    },
  },
  data () {
    return {}
  },
  computed: {
    offsetStyle () {
      return {
        left: this.percent + '%',
      }
    },
    offsetStyleSec () {
      return {
        left: this.secPercent + '%',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.vernier {
  position: relative;
  .horizon{
    $divisionLength: 2px;
    height: 1px;
    position: relative;
    border-bottom: 1px dashed #d8d3d3;
    .division {
      display: inline-block;
      height: 2px;
      margin-left: 33%;
      outline: 1px  solid #d8d3d3;
      float: left;
    }
    .division:first-child {
      margin-left: 0;
    }
    .division:last-child {
      margin-left:0;
      float: right;
    }
  }
  .dot {
    position: absolute;
    border-radius: 50%;
    top: -4px;
    height: 3px;
    width: 3px;
    display: inline-block;
    border: 5px solid #0c3a58;
    transform: translateX(-5px);
    z-index: 2;
  }
  .secDot{
    @extend .dot;
    z-index: 1;
    border-color: #b1c3cf;
  }
}
</style>
